import PropTypes from 'prop-types'
import React, {Component} from 'react'
import {Responsive} from "semantic-ui-react";
import MobileMenu from "./MobileMenu";

class MobileContainer extends Component {
  render() {
    return (
      <Responsive maxWidth={767}>
        <MobileMenu children={this.props.children}/>
      </Responsive>
    )
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
};

export default MobileContainer



// WEBPACK FOOTER //
// ./src/components/mobile/MobileContainer.js